export class TipoTaxaEsporadica {
  id: number = 0;
  name: string= '';
  createdBy: string= '';
  createdOn?: Date =  new Date();
  updatedBy?: string= '';
  updatedOn?: Date =  new Date();
  isEnabled: boolean
}
